import { Component, Input, OnInit } from '@angular/core';
import { HxPagedListDirective } from 'hx-components';
import { HxProductSplitDefinitionService, HxUiLabelPipe, PagedList, ProductSplitDefinitionFullModel } from 'hx-services';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { takeUntil } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { NgFor } from '@angular/common';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';

@Component({
    selector: 'hc-product-def-split-list',
    templateUrl: './product-def-split-list.component.html',
    styleUrls: ['./product-def-split-list.component.less'],
  imports: [TranslocoDirective, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderExtraDirective, NzButtonComponent, RouterLink, NzIconDirective, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzTbodyComponent, NgFor, NzButtonGroupComponent, NzWaveDirective, NzPopconfirmDirective, HxUiLabelPipe, TranslocoPipe]
})
export class ProductDefSplitListComponent extends HxPagedListDirective<ProductSplitDefinitionFullModel> implements OnInit {
  @Input() productInfoId!: number;

  constructor(
    override router: Router,
    override aRoute: ActivatedRoute,
    protected productSplitDefinitionService: HxProductSplitDefinitionService,
    protected notification: NzNotificationService,
    protected tr: TranslocoService,
  ) {
    super(router, aRoute);
    this.limit = 20;
  }

  ngOnInit() {
    this.aRoute.queryParamMap.pipe(takeUntil(this.$destroyed))
      .subscribe(paramMap => super.load(paramMap));
  }


  remove(id: number): void {
    this.productSplitDefinitionService.deleteProductSplitDefinitionById(id).subscribe(() => this.loadData());
  }

  protected loadList(): Promise<PagedList<ProductSplitDefinitionFullModel>> {
    return firstValueFrom(this.productSplitDefinitionService.getProductSplitDefinitions({ inProductInfoId: this.productInfoId }));
  }
}
